import * as React from 'react';

interface BackgroundImageProps {
	imageUrl: string;
}

export const BackgroundImage: React.FC<BackgroundImageProps> = ({
	imageUrl,
}) => {
	return (
		<img
			src={imageUrl}
			alt='Background decoration'
			className='object-cover absolute inset-0 size-full'
		/>
	);
};
